var DeskMessage = (function () {
    function DeskMessage() {
    }
    return DeskMessage;
}());
export { DeskMessage };
